import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'sm-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss']
})
export class CustomSnackbarComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private activesnackbarref: MatSnackBarRef<CustomSnackbarComponent>) { }

  ngOnInit(): void {
  }
  onRefresh() {
    if (this.data.onRefresh) {
      this.data.onRefresh();
      this.activesnackbarref.dismiss() // Execute a custom refresh function if provided
    }
  }

  onclose(){
    this.activesnackbarref.dismiss()
  }
}
